var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "card" },
      [_c("v-scheduled-messages-list", { attrs: { allEndUsers: 1 } })],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("h1", [_vm._v("Messages")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }